import dayjs from 'dayjs';
import { FC } from 'react';
import { DatePicker } from '../DatePicker';

interface Props {
	value: string | null;
	onChange: (value: string | null) => void;
	disabled: boolean;
	errorMessage: string | undefined;
	label?: string;
	className?: string;
}

export const ReferenceDatePicker: FC<Props> = (props) => {
	const {
		value, //
		onChange,
		disabled,
		errorMessage,
		label,
		className,
	} = props;

	const maxDate = dayjs().endOf('year');
	const minDate = maxDate.subtract(5, 'years');

	// * Render
	return (
		<DatePicker
			className={className}
			label={label}
			value={value ? dayjs(value) : undefined}
			onChange={(date) => onChange(date === null ? null : date.endOf('year').startOf('day').format('YYYY-MM-DDTHH:mm:ss'))}
			minDate={minDate}
			maxDate={maxDate}
			picker="year"
			disabled={disabled}
			allowClear={false}
			error={errorMessage}
			size="middle"
		/>
	);
};
